import directive from './directive'

import HsContextmenu from './components/Contextmenu.vue'
import HsContextmenuItem from './components/ContextmenuItem.vue'
import HsContextmenuGroup from './components/ContextmenuGroup.vue'
import HsContextmenuSubmenu from './components/ContextmenuSubmenu.vue'
import './styles/index.scss';

const install = (Vue) => {
  Vue.directive('contextmenu', directive)

  Vue.component(HsContextmenu.name, HsContextmenu)
  Vue.component(HsContextmenuItem.name, HsContextmenuItem)
  Vue.component(HsContextmenuGroup.name, HsContextmenuGroup)
  Vue.component(HsContextmenuSubmenu.name, HsContextmenuSubmenu)
}

export {
  directive,

  HsContextmenu,
  HsContextmenuItem,
  HsContextmenuGroup,
  HsContextmenuSubmenu
}

if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue)
}

export default {
  install,
}
